import React from "react";
import { TriptychLayout } from '../../components/layout/TriptychLayout';
import Text from '../../components/common/Text';
import Paragraph from '../../components/common/Paragraph';
import EvaluationSurvey from './components/EvaluationSurvey';
import VanTrustContactInfo from "../HomePage/components/VanTrustContactInfo";

const EvaluationPage = () => 
  <TriptychLayout noAppendPadding hideAppend={false}>
    <div>
      <Text style={{ fontSize: 20, fontWeight: "bold" }}>Evalúa la atención de tu ejecutivo</Text>
      <Paragraph style={{ marginTop: 20 }}>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquam asperiores aspernatur autem corporis cumque cupiditate doloremque</Paragraph>
    </div>
    <EvaluationSurvey />
    <VanTrustContactInfo />
  </TriptychLayout>

export default EvaluationPage;